import { useQuery } from '@tanstack/react-query';
import { AdminSequencesAPI } from '../../../lib/apiAdmin';

export const templateFoldersKey = ['admin', 'email-template-folders'];
export const useTemplateFolders = (enabled = true) => useQuery({
  queryKey: templateFoldersKey,
  queryFn: () => AdminSequencesAPI.listTemplateFolders(),
  enabled,
});
